module.exports = __webpack_public_path__ + "static/media/stephanieShortboard.32f4f5c3.jpg";